const baguetteBox = require('baguettebox.js');

window.addEventListener('DOMContentLoaded', () => {
  baguetteBox.run('.gallery', {
    captions: function(element) {
      const caption = element.parentNode.querySelector('figcaption');
      if(caption) {
        return caption.textContent;
      }
      return '';
    },
  });
});
